import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@resiliatech/birdsong'

const NoAccessPage = () => (
  <PageContainer>
    <ContentContainer>
      <Title>Contact a team admin to get access to this feature</Title>
      <Subtitle>You can view your team admins in the Team page.</Subtitle>
      <a href='/team'>
        <Button variant='outlined' color='primary' size='large'>
          Visit Team Page
        </Button>
      </a>
    </ContentContainer>
  </PageContainer>
)

export default NoAccessPage

const PageContainer = styled('div')`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-top: -25.5px;
`

const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 565px;
`

const Title = styled('div')`
  font-family: Merriweather;
  font-size: 34px;
  line-height: 40.8px;
  text-align: center;
  font-weight: 400;
`

const Subtitle = styled('div')`
  margin: 20px 0;
`
